import { Component, AfterViewInit, ElementRef, effect, afterRenderEffect, inject, ChangeDetectionStrategy, viewChild, viewChildren, ChangeDetectorRef } from '@angular/core';

import PerfectScrollbar from 'perfect-scrollbar';

import { UtilityFunctionService } from '@providers/common/utilityFunction.service';

import { LayoutService } from '@providers/common/layout.service';

import { MenuBaseComponent } from '@components/menu-base/menu-base.component';
import { addIcons } from "ionicons";
import { menu, home, cashOutline, apertureOutline, fileTrayFullOutline, folderOutline, location, list, repeatSharp, car, document as documentIcon, businessOutline, search, layersOutline, bus, compass, alert, star, peopleCircle, settings, ellipsisVerticalOutline, bagOutline, logOutOutline, earth, personCircleOutline, medalOutline, peopleOutline, serverOutline, podium } from "ionicons/icons";
import { IonItem, IonLabel, IonIcon, IonGrid, IonRow, IonCol } from '@ionic/angular';
import { NgClass, TitleCasePipe } from '@angular/common';
import { MyMenuComponent } from './my-menu.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'csi-menu-lat',
    templateUrl: './menu-lat.component.html',
    styleUrls: ['./menu-lat.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IonItem,
        IonLabel,
        IonIcon,
        NgClass,
        IonGrid,
        IonRow,
        IonCol,
        MyMenuComponent,
        TitleCasePipe,
        TranslatePipe,
    ],
})
export class MenuLatComponent
    extends MenuBaseComponent
    implements AfterViewInit {
    private utilityService = inject(UtilityFunctionService);
    private cdr = inject(ChangeDetectorRef);

    // Propio del menu de escritorio: panel de administrador y submenu de apps Ontrack.
    showAdminPanel = false;
    showOntrackMenu = false;

    public showQuantumCivarMenu: boolean[] = [];

    readonly submenuOntrackElem = viewChild<ElementRef>('submenuOntrackElem');
    readonly asideElem = viewChild<ElementRef>('asideElem');
    readonly scrollbarContainer = viewChild<ElementRef>('scrollbarContainer');
    isStatic = true;
    endedMenuInit = false;
    ps: any = null;
    transitionEnd: string | null = null;
    openedFirstTime = false;

    readonly quantumCivarElems = viewChildren<ElementRef>('quantumCivarElems');
    addedEventListener = false;

    readonly homeSubmenuElem = viewChild<ElementRef>('homeSubmenuElem');
    HOME_SUBMENU_DEFAULT_HEIGHT = 86;

    constructor() {
        super();

        this.initializeApp();

        this.subs.push(this.events.subscribe('menuLoad', () => {
            this.initializeApp();
        }));

        // La visibilidad del menu la controla app.component.html con LayoutService.useMobileNav().
        // Mientras esta oculto, PerfectScrollbar mide 0; al volver a mostrarse se recalcula.
        const layout = inject(LayoutService);
        effect(() => {
            if (!layout.useMobileNav() && this.ps) {
                setTimeout(() => { this.ps.update(); this.cdr.markForCheck(); });
            }
        });
        // Al renderizarse por primera vez los submenus Civar, recalcula el scroll al terminar su transicion
        afterRenderEffect(() => {
            const elems = this.civarElems();
            if (this.transitionEnd === null || this.addedEventListener || elems.length === 0) return;
            this.addedEventListener = true;
            elems.forEach((el) => {
                el.nativeElement.addEventListener(this.transitionEnd, () => {
                    this.ps.update();
                    this.ps.update();
                });
            });
        });
        addIcons({ menu, home, cashOutline, apertureOutline, fileTrayFullOutline, folderOutline, location, list, repeatSharp, car, document: documentIcon, businessOutline, search, layersOutline, bus, compass, alert, star, peopleCircle, settings, ellipsisVerticalOutline, bagOutline, logOutOutline, earth, personCircleOutline, medalOutline, peopleOutline, serverOutline, podium });
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();

        this.isStatic = this.userProvider.isMenuStatic();
        if (!this.isStatic) {
            this.toggleStaticMenu(false);
        }
        this.transitionEnd = this.whichTransitionEnd();
        this.ps = new PerfectScrollbar(this.scrollbarContainer().nativeElement, {
            suppressScrollX: true,
            wheelPropagation: false,
        });

        setTimeout(() => {
            this.toggleShowMoreSubmenu();
            this.cdr.markForCheck();
        }, 1000);
    }

    whichTransitionEnd() {
        const el = document.createElement('div');

        const transEndEventNames = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend',
        };

        for (const name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return transEndEventNames[name];
            }
        }

        return null;
    }

    initializeApp() {
        this.storage.get('userMenu').then((data: any) => {
            if (data) {
                this.applyMenuPreferences(data);
            }
        });
    }

    protected override reloadMenu(): void {
        this.initializeApp();
    }

    protected override onMenuDataProcessed(_data: any): void {
        this.endedMenuInit = true;
        const asideElem = this.asideElem();
        if (asideElem && asideElem.nativeElement && this.isStatic) {
            this.showQuantumMenu = true;
        }
    }

    protected override afterMenuTransition(): void {
        if (this.transitionEnd === null) {
            setTimeout(() => {
                this.ps.update();
                this.ps.update();
                this.cdr.markForCheck();
            }, 500);
        }
    }

    mouseEnter() {
        if (!this.isStatic && !this.openedFirstTime) {
            this.openedFirstTime = true;
            this.showQuantumMenu = true;
            const submenuElem = this.submenuElem();
            if (
                (submenuElem && submenuElem.nativeElement,
                    this.submenuElem().nativeElement.scrollHeight)
            ) {
                setTimeout(
                    () => {
                        this.submenuElem().nativeElement.style.maxHeight =
                            this.submenuElem().nativeElement.scrollHeight + 'px';
                            this.cdr.markForCheck();
                    },
                    this.endedMenuInit ? 0 : 500,
                );
            }
        }
    }

    toggleStaticMenu(publishEvent = true) {
        const asideElem = this.asideElem();
        if (asideElem && asideElem.nativeElement) {
            // Posicionamiento del menu
            const added =
                asideElem.nativeElement.classList.toggle('static-menu');
            this.userProvider.setMenuStatic(added);
            this.isStatic = added;
            if (publishEvent) this.events.publish('staticmenu:toggle');
        }
    }

    toggleAppsMenu() {
        this.showOntrackMenu = !this.showOntrackMenu;
        this.submenuOntrackElem().nativeElement.style.maxHeight = this
            .showOntrackMenu
            ? this.submenuOntrackElem().nativeElement.scrollHeight + 'px'
            : '0px';

        this.afterMenuTransition();
    }

    goToAdminPanel() {
        this.sendNav.emit(61);
    }

    goToWebFrame() {
        this.sendNav.emit(100);
    }

    goToiFramePage() {
        const routeParams = {
            // Se genera un objeto con los parametros a transmitir a la siguiente route
            externalURL: 'https://ws.csigroup.com.mx/csi-quantumontrack/plan-viajes2', // URL del item a mostrar en el frame
            routeId: this.utilityService.randomNum(),
        };

        this.storage.put('Quantum:externalURL', routeParams);

        this.sendNav.emit(110);
    }

    /**
     * @name autoLoginARTUS
     * @description Metodo que hace un inicio de sesion en el sistem ARTUS
     */
    autoLoginARTUS(item, user, pass, dashboard) {
        if (user != null && pass != null) {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = 'https://aws.csigroup.com.mx/ARTUSG9/LoadStage.php';
            form.target = '_blank';

            form.method = 'POST';
            const element1 = document.createElement('input');
            const element2 = document.createElement('input');
            const element3 = document.createElement('input');
            const element4 = document.createElement('input');
            const element5 = document.createElement('input');

            element1.id = 'repository';
            element1.name = 'txtRepositorio';
            element1.value = 'BISunusProd';
            form.appendChild(element1);

            element2.id = 'username';
            element2.name = 'txtUser';
            element2.value = user;
            form.appendChild(element2);

            element3.id = 'password';
            element3.name = 'txtPassword';
            element3.value = pass;
            form.appendChild(element3);

            element4.name = 'txtNumEsc';
            element4.value = dashboard;
            form.appendChild(element4);

            element5.name = 'txtParametros';
            element5.value = 'TPParams';
            form.appendChild(element5);

            document.body.appendChild(form);

            form.submit();
        } else {
            if (
                this.plt.is('mobile') &&
                (this.plt.is('android') || this.plt.is('ios'))
            ) {
                this.capacitorService.goToLaunchBrowser(item.Desc_Pagina);
            } else {
                if (item.Bit_Frame) {
                    const routeParams = {
                        // Se genera un objeto con los parametros a transmitir a la siguiente route
                        externalURL: item.Desc_Pagina, // URL del item a mostrar en el frame
                        routeId: item.Id_Cnsc_Menu,
                    };
                    this.dataService.setData(routeParams.routeId, routeParams); // Con ayuda del provider DataService asignamos el objeto parametros a un iD, para de esta manera poder recibirlo en la siguiente ruta/pantalla
                    this.storage.put(routeParams.routeId, routeParams); // Con ayuda del provider StorageService asignamos el objeto parametros a un iD, para de esta manera poder obtenerlo desde el storage en caso de necesitarlo en la siguiente ruta/pantalla

                    this.router.navigate(['/quantum/civar/' + routeParams.routeId], {
                        replaceUrl: true,
                    });
                } else {
                    window.open(item.Desc_Pagina, '_blank');
                }
            }
        }
    }
}
